/**
 * @file Which of a contract's charge templates a renewal copies: a once template holds for the whole string of renewed contracts, so it is left out.
 * No failure path: an absent list gives an empty one.
 */
import PeriodContainer from "../Charge/Period/PeriodContainer";
import { ChargeTemplateInterface } from "../Charge/ChargeTemplateInterface";

export function getChargeTemplatesForRenewal(chargeTemplates: ChargeTemplateInterface[]): ChargeTemplateInterface[] {
  return (chargeTemplates || []).filter(chargeTemplate =>
    !!chargeTemplate && chargeTemplate.repeatPeriod?.id !== PeriodContainer.pickIdFromLabel("once"));
}
